export type PartnerLogo =
  | { type: 'image'; src: string; alt: string; className?: string }
  | { type: 'wordmark'; alt: string; className?: string };

export type PressRelease = {
  slug: string;
  title: string;
  excerpt: string;
  date: string; // ISO yyyy-mm-dd
  image: string;
  featuredImage?: string;
  partnerLogos?: PartnerLogo[];
  titleHighlights?: string[];
  imageAlignment?: 'left' | 'center' | 'right';
  category?: string;
  tagline?: string;
  location?: string;
  ctaSubline?: string;
  draft?: boolean;
  hasVideo?: boolean;
};

export const AI_SUITE_LAUNCH_SLUG = '12-10-2026-bunker-suite-launches-integrated-ai-for-bunker-traders-and-suppliers';
// Mux playback ID of the AI launch film.
export const AI_SUITE_LAUNCH_VIDEO = 'tfs4yrnETAofP6318CzPJ4qsXmenLxXhLgoYl7llBk8';
export const AI_SUITE_LAUNCH_STILLS = [
  {
    src: 'cfimg:d6d003e8-12ef-47e6-d17e-65998093cd00',
    alt: 'The Bunker Suite AI mark glowing inside an opened shipping container at night',
  },
  {
    src: 'cfimg:ad1bd304-5ac9-47eb-991c-c32c66960200',
    alt: 'The Bunker Suite AI assistant with a margin question typed in plain language',
  },
  {
    src: 'cfimg:d72821f1-a19c-416f-5425-84edf77b1a00',
    alt: 'A trader reviewing compliance checks on a vessel and its owner, including sanctions screening',
  },
] as const;

const PRESS_RELEASES: readonly PressRelease[] = [
  {
    slug: AI_SUITE_LAUNCH_SLUG,
    title: 'Bunker Suite launches integrated AI for bunker traders and suppliers',
    excerpt:
      'Building on AI enquiry capture, the rollout extends to confirmations, BDNs, invoices and questions about the desk’s own business.',
    date: '2026-10-12',
    image: 'cfimg:f53c91d2-ff92-488d-84e1-0e9a7bcb4800',
    titleHighlights: ['integrated AI'],
    imageAlignment: 'center',
    category: 'Press release',
    tagline: 'Integrated AI',
    location: 'Dubai, UAE',
    ctaSubline: 'Watch the launch video',
    hasVideo: true,
  },
  {
    slug: '18-11-2025-bunker-suite-successfully-completes-first-e-bdn-trial-onboard-lady-clara',
    title: 'Bunker Suite successfully completes first E-BDN trial onboard Lady Clara',
    excerpt:
      'Bunker Suite announces the successful completion of the first Electronic Bunker Delivery Note (E-BDN) trial, marking an important milestone in the digitalization of bunker delivery processes.',
    date: '2025-11-18',
    image: 'cfimg:a9a4ab59-fce5-4afb-1739-477eb3db8600',
    featuredImage: 'cfimg:34ec2121-8e81-4c96-7d7f-ff685dcd3b00',
    partnerLogos: [
      { type: 'image', src: '/svg/logo-vertom.svg', alt: 'Vertom', className: 'opacity-85' },
      { type: 'image', src: '/svg/logo-vme.svg', alt: 'Verde Marine', className: 'opacity-85' },
    ],
    titleHighlights: ['successfully completes'],
    imageAlignment: 'center',
    category: 'Press release',
    tagline: 'E-BDN',
    location: 'Dubai, UAE',
    ctaSubline: 'See the Lady Clara workflow',
    hasVideo: true,
  },
  {
    slug: '28-02-2026-bunker-suite-launches-next-gen-platform',
    title: 'Bunker Suite launches the next-generation Bunker Suite Platform',
    excerpt:
      'We are introducing our most advanced platform yet — built with AI-native workflows, predictive deal desks, and real-time visibility across commercial, finance, and operations teams.',
    date: '2026-02-28',
    image: 'cfimg:5eba6274-652b-473f-7041-0e78ac6c3100',
    featuredImage: 'cfimg:5eba6274-652b-473f-7041-0e78ac6c3100',
    partnerLogos: [{ type: 'wordmark', alt: 'Bunker Suite' }],
    titleHighlights: ['next-generation'],
    imageAlignment: 'left',
    category: 'Press release',
    tagline: 'Next-gen platform',
    location: 'Dubai, UAE',
    ctaSubline: 'See what’s new in Bunker Suite',
    draft: true,
  },
] as const;

export function getPressReleases(): PressRelease[] {
  return [...PRESS_RELEASES];
}

export function getPressReleaseBySlug(slug: string): PressRelease | undefined {
  return PRESS_RELEASES.find((item) => item.slug === slug);
}
